import React from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Splash from "../components/splash"
import ViewMore from "../components/viewMore"
import styled from "@emotion/styled"
import LongBlocks from "../components/longBlocks"
import { CAPABILITIES } from "../config"

const CapabilitiesTemplate = ({ images, options }) => (
  <Layout>
    <SEO title={`Capabilities | ${options.title}`} />
    <Splash subtitle="Capabilities" title={`${options.title}`}>
      <Img style={{ minHeight: "150px" }} fluid={images[images.length - 1]} />
    </Splash>
    <Container>
      <section>
        <div className="summary">
          {options.longText.map(t => (
            <>
              <p>{t}</p>
              <br />
            </>
          ))}
        </div>
      </section>
      <ViewMore>
        <ul>
          <p>View Other Capabilities</p>
          {Object.keys(CAPABILITIES).map(k => (
            <li>
              <Link to={CAPABILITIES[k].href}>{CAPABILITIES[k].title}</Link>
            </li>
          ))}
        </ul>
      </ViewMore>
    </Container>
    <div className="capabilities">
      <h3>{options.title} Case Studies: </h3>
      <LongBlocks blocks={options.studies.map(b => renderBlock(b))} />
    </div>
  </Layout>
)

const renderBlock = block => {
  const title = block.title
  const text = block.summary.about
  const href = block.href
  const capabilities = block.summary.capabilities
  return {
    title,
    text,
    href,
    capabilities,
    case: block.id,
  }
}

const Container = styled.div`
  display: flex;
  margin: 0;
  line-height: 26px;
  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    text-align: center;
  }
  font: 400 ${props => props.theme.fontSize.paragraph}
    ${props => props.theme.fonts.sans};
  section {
    flex-basis: 60%;
  }

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    display: block;
  }

  margin: 4rem auto 2rem;
  color: ${props => props.theme.colors.secondary};

  section {
    font-size: ${props => props.theme.fontSize.summary};
    line-height: ${props => props.theme.lineHeight.summary};
    margin: 3rem 0;
    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
      text-align: center;
      margin: 0rem 0rem;
      font-size: ${props => props.theme.fontSize.summaryTablet};
      line-height: ${props => props.theme.lineHeight.summaryTablet};
    }
  }
  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    margin: 2rem 0;
  }
`

export default CapabilitiesTemplate
